export const TWITTER_URL="https://twitter.com/intent/tweet"
export const TELEGRAM_URL="https://telegram.me/share/url"
export const DEFAULT_TIME_ZONE="UTC"
